var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "231px",
    height: "231px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.4909983633387888s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.692307692307693 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.45008183306055644s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461539 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.40916530278232405s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.07692307692308 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.36824877250409166s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923077 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.3273322422258592s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153845 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.2864157119476268s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.15384615384616 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.2454991816693944s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.20458265139116202s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846155 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.1636661211129296s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.1227495908346972s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.9230769230769 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.0818330605564648s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.61538461538464 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "-0.0409165302782324s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 23.5,
    rx: 3.25,
    ry: 3.25,
    width: 7,
    height: 13,
    fill: "#706668"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5319148936170213s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.f4b4c69c5d256cc9b65ee2aeecbec9ac.svg";
export { ForwardRef as ReactComponent };